export default "<footer class=\"ms-footer\">\n    <div class=\"container\">\n        <p>Copyright &copy; Material Style 2017</p>\n    </div>\n</footer>";